import React from "react";
import { Button } from "./Button";

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  };
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className = "",
}: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-slate-50/70 px-4 py-12 text-center ${className}`}
    >
      {icon && (
        <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border border-slate-200 bg-white text-3xl text-slate-400 shadow-sm">
          {icon}
        </div>
      )}
      <h3 className="mb-2 text-lg font-black text-slate-950">{title}</h3>
      {description && (
        <p className="mb-6 max-w-md text-sm font-medium text-slate-500">{description}</p>
      )}
      {action && (
        <Button onClick={action.onClick} variant="primary" leftIcon={action.icon}>
          {action.label}
        </Button>
      )}
    </div>
  );
}
